import { render } from "./RevFund2.vue?vue&type=template&id=63ad1a96"
import script from "./RevFund2.vue?vue&type=script&lang=js"
export * from "./RevFund2.vue?vue&type=script&lang=js"

import "./RevFund2.vue?vue&type=style&index=0&id=63ad1a96&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__